import Joi from 'joi';

import { UserTypeEnum } from '../../enums/user-type.enum';

/**
 * Schema for existing user record validation.
 */
export const updateUserSchema = () =>
	Joi.object({
		type: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|user-type|cannot-be-null',
				}),
				otherwise: Joi.string()
					.valid(...Object.values(UserTypeEnum))
					.required()
					.messages({
						'any.required': 'validations|user-type|required',
						'any.only': 'validations|user-type|invalid-value',
						'string.base': 'validations|user-type|must-be-string',
						'string.empty': 'validations|user-type|cannot-be-null',
					}),
			})
			.prefs({ abortEarly: true }),
	})
		// Ignore extra fields
		.unknown();
